import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M17.5 18.5L24 12L17.5 5.5L16.793 6.207L22.086 11.5L0 11.5V12.5L22.086 12.5L16.793 17.793L17.5 18.5Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "ThinBigRight"
);
